<template>
  <div class="assessment-create-element-option container-fluid margin-Bottom-1Point5Perc margin-Top-2Point5Perc"> 
    <div class="admin-Panel-Padding">
      <div class="row">
        <div class="col-sm-2 col-md-3 col-lg-3">
        </div>
        <div class="col-xs-8 col-sm-4 col-md-3 col-lg-3">
          <select class="form-control" v-model="selectedElementType">
            <option value=-1 disabled>Select Step to be added</option>
            <option value="3">MCQ Quiz</option>
            <option value="2">Reflection</option>
          </select>
        </div>
        <div class="col-xs-8 col-sm-4 col-md-3 col-lg-3">
          <button class="btn btn-primary btn-block center-align-div create-element-button-BG black-font-color" v-on:click="openSelectedElement($event,false)">+ Create Step</button>
        </div>
        <div class="col-md-3 col-lg-3">
        </div>
      </div>
    </div> 
    <create-assessment-reflection-discussion-element v-if="isRD" @closePopUp="closeOverlay"></create-assessment-reflection-discussion-element>
    <create-assessment-mcq-element v-if="isMCQ" @closePopUp="closeOverlay"></create-assessment-mcq-element>
    
    <!-- Alert Overlay -->
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div>
    <loader></loader>
  </div>    
</template>

<script>
import Loader from '@/components/dashboard/Loader'
// import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import CreateAssessmentReflectionDiscussionElement from '@/components/assessment_journey/CreateAssessmentReflectionDiscussionElement'
import CreateAssessmentMCQElement from '@/components/assessment_journey/CreateAssessmentMCQElement'
export default {
  props: ['assessementObj'],
  name: 'assessment-create-element-option',
  data: function () {
    return {
      selectedElementType: -1,
      isMCQ: false,
      isRD: false,
      errorMsg: '',
      showAlertDialog: false,
      showSpinner: false
    }
  },
  components: {
    'alert-box': AlertBox,
    'create-assessment-reflection-discussion-element': CreateAssessmentReflectionDiscussionElement,
    'create-assessment-mcq-element': CreateAssessmentMCQElement,
    'loader': Loader
  },
  methods: {
    closeOverlay (value) {
      const openOverlayFlag = value.openOverlay
      const newObj = value.newObj
      this.selectedElementType = -1
      this.isMCQ = openOverlayFlag
      this.isRD = openOverlayFlag
      if (newObj !== undefined && newObj !== 'undefined' && newObj !== null && newObj !== 'null' && newObj !== '') {
        this.$store.state.selectedAssessmentElementList.push(value.newObj)
      }
      this.$store.state.isOverlayVisible = false
    },
    openSelectedElement: function (event) {
      if (this.selectedElementType === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a step.'
      } else {
        // AK: Disable background scrolling
        this.$store.state.isOverlayVisible = true
        switch (this.selectedElementType) {
          case '2':
            this.isRD = true
            break
          case '3':
            this.isMCQ = true
            break
        }
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    }
  },
  computed: {}
}
</script>
<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
  padding-top: 6%;
  padding-bottom: 6%;
}

.overlay-content {
  position: relative;
  /*top: 25%;*/
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}

.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-3Perc {
  margin-right: 3%;
}
.width {
  width: 95%;
}

.vertical-align {
  display: flex;
  align-items: center;
}
.create-element-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-element-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.margin-Bottom-1Point5Perc {
  padding-bottom: 1.5%;
}
.margin-Top-2Point5Perc {
  padding-top: 2.5%;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.center-align-div {
  margin: 0 auto;
}
.cursor-pointer {
  cursor: pointer;
}
.font-wight-bold {
  font-weight: bold;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.create-element-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000;
}
.overlay-select-menu-width-93Perc {
  width: 93% !important;
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.float-right {
  float: right;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.border-color-green {
  border: 1px solid green;
}
.border-color-black {
  border: 1px solid black;
}
.border-red {
  border: 1px solid red;
}
</style>



// WEBPACK FOOTER //
// src/components/assessment_journey/AssessmentCreateElementOption.vue